import { SitemodelContextValue } from 'sitemodel/shared/types'

type IsInaccessibleSitemodelArgs = {
  isFetched: boolean
  isFetchedHome: boolean
  isIndex?: boolean
  content: SitemodelContextValue
}

export const isInaccessibleSitemodel = ({
  isFetched,
  isFetchedHome,
  isIndex,
  content
}: IsInaccessibleSitemodelArgs): boolean => {
  return (isFetched || (isFetchedHome && !!isIndex)) && !content.service
}
